import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useRef, useState } from "react";
import { API } from "../url";
import "./homeScroll.css";

const HomeScroll = ({ homeSecondData, isDesktop, isMobile }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [clip, setClip] = useState(0);
  const [top, setTop] = useState();
  const [bottom, setBottom] = useState();
  const [vSize, setVSize] = useState();
  const [onHover, setOnHover] = useState(false);

  const hero1 = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const getTopHeight = () => {
      const rect1 = hero1.current.getBoundingClientRect();
      const topHeight = rect1.top + window.scrollY;
      const bottomHeight = rect1.bottom + window.scrollY;
      setTop(topHeight);
      setBottom(bottomHeight);
    };
    getTopHeight();
    const handleScroll = () => {
      getTopHeight();
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (scrollPosition > top && scrollPosition <= bottom) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, [scrollPosition, top, bottom]);

  useEffect(() => {
    const handleScroll = () => {
      const currentPosition = window.scrollY || window.pageYOffset;
      setScrollPosition(currentPosition);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const rangeStart = top || 0;
    const rangeEnd = bottom || window.innerHeight; // Fallback to window height if bottom is undefined
    const range = rangeEnd - rangeStart;

    // Calculate clip value from 100 to 0 based on scroll position
    // const newClip2 = 30 - ((scrollPosition - rangeStart) / range) * 100;
    const newClip = 15 - ((scrollPosition - rangeStart) / range) * 100;

    if (newClip > 3) {
      setClip(Math.max(0, Math.min(newClip, 100))); // Ensure it's between 0 and 100
    }
    const videoSize = 1 + scrollPosition * 0.04;

    if (videoSize < 60) {
      setVSize(Math.min(videoSize, 200));
    }
  }, [scrollPosition, top, bottom]);

  return (
    <div>
      {isDesktop ?
        <div class="homeHero2">
          <div class="homeHero1" ref={hero1}>
            <div class="homeHero1S" style={{ position: "sticky", top: "0" }}>
              <div class="homeHero1R" style={{ position: "relative" }}>
                <div class="homeHero1R1"></div>
                <div
                  onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)}
                  class="homeHero1A "
                  style={{
                    clipPath: `inset(${3.5}% ${clip}% ${clip * 2
                      }% ${clip}% round 20px`,
                  }}
                >
                  <div style={{ height: `100%`, width: `100%` }} >

                    {onHover ? homeSecondData?.desktop_youtube_link ? <iframe
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      height='100%' width='100%' data-gtm-yt-inspected-8="true" src={homeSecondData?.desktop_youtube_link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                    </iframe> : <video
                      class=" pcVideo"
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    >
                      <source
                        src={
                          API + homeSecondData?.desktop_video}
                        type="video/mp4"
                      />
                    </video> : <img
                      class=" pcVideo"
                      src={
                        API + homeSecondData?.desktop_image
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />}


                    {onHover ? <video
                      class=" mbVideo"
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    >
                      <source
                        src={API +
                          homeSecondData?.mobile_video}
                        type="video/mp4"
                      />
                    </video> : <img
                      class=" mbVideo"
                      src={
                        API + homeSecondData?.mobile_image
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> :
        isMobile ? <div class="homeHero2">
          <div class="homeHero1" ref={hero1}>
            <div class="homeHero1S" style={{ position: "sticky", top: "0" }}>
              <div class="homeHero1R" style={{ position: "relative" }}>
                <div class="homeHero1R1"></div>
                <div
                  onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)}
                  class="homeHero1A "
                  style={{
                    clipPath: `inset(${3.5}% ${clip}% ${clip * 2
                      }% ${clip}% round 20px`,
                  }}
                >
                  <div style={{ height: `100%`, width: `100%` }} >

                    {onHover ?homeSecondData?.mobile_youtube_link ? <iframe
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      height='100%' width='100%' data-gtm-yt-inspected-8="true" src={homeSecondData?.mobile_youtube_link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                    </iframe> : <video
                      class=" mbVideo"
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    >
                      <source
                        src={API +
                          homeSecondData?.mobile_video}
                        type="video/mp4"
                      />
                    </video> : <img
                      class=" mbVideo"
                      src={
                        API + homeSecondData?.mobile_image
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />}

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div> : ''}
    </div>
  );
};

export default HomeScroll;
